import React from 'react';
import { mapKeys } from 'lodash';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';
import {
    DEFAULT_SOURCE,
    ATTRIBUTES_MAP,
} from '../../../../shared/data/analytics';
import { resolvePageForEvent } from '../../../../shared/utilities/events';
import { getViewabilityEvent } from '../../../utilities/getViewabilityEvent';
import { useStateContext } from '../../../modules/stateContext';
import { SINGLE_ENTRY_AUTH_UK_EXPERIMENT } from '../../../../shared/data/mvtExperiments';
import { useViewabilityEvents } from '../../../hooks/useViewabilityEvents';

const getContainer = pathname => pathname.split('/')[1];

const Track = ({
    children,
    container,
    'data-testid': dataTestId,
    name,
    result,
    type,
    source,
    ignoreViews,
    metadata,
}) => {
    const stringifiedMetadata = JSON.stringify(metadata);
    const { pathname } = useLocation();
    const {
        featureToggles: { enableSingleAuthEntryUk },
        policy,
        isSingleEntryAuth,
        location: { isUk },
        isFederated,
        journeyGroupType,
        sequenceId,
        pageMetadata,
    } = useStateContext();

    const { applyViewabilityEvents } = useViewabilityEvents();

    const isSingleAuthUkEnabled =
        enableSingleAuthEntryUk && isUk && !isFederated;

    const containerName =
        pageMetadata?.pageName ||
        resolvePageForEvent(container || getContainer(pathname));

    const givenAttributes = {
        container: containerName,
        name,
        result,
        type,
        source: source || DEFAULT_SOURCE,
        ignoreViews: ignoreViews ? '1' : undefined,
        metadata: stringifiedMetadata,
    };

    if (isSingleAuthUkEnabled && policy === 'tv') {
        givenAttributes.personalisation = JSON.stringify({
            EXP: isSingleEntryAuth
                ? SINGLE_ENTRY_AUTH_UK_EXPERIMENT.VARIATION.SINGLE_AUTH_ENTRY
                : SINGLE_ENTRY_AUTH_UK_EXPERIMENT.VARIATION.CONTROL,
        });
    }

    const mappedAttributes = applyViewabilityEvents
        ? getViewabilityEvent(
              containerName,
              pathname,
              ignoreViews,
              name,
              type,
              journeyGroupType,
              sequenceId
          )
        : mapKeys(givenAttributes, (value, propertyKey) =>
              ATTRIBUTES_MAP.get(propertyKey)
          );

    return (
        <div data-testid={dataTestId} {...mappedAttributes}>
            {children}
        </div>
    );
};

Track.propTypes = {
    children: PropTypes.node.isRequired,
    container: PropTypes.string,
    'data-testid': PropTypes.string,
    name: PropTypes.string,
    result: PropTypes.string,
    type: PropTypes.string,
    source: PropTypes.string,
    ignoreViews: PropTypes.bool,
    metadata: PropTypes.objectOf(PropTypes.string),
};

export default Track;
